/** Format unknown thrown values for tool/user-facing error strings. */
export function formatUnknownError(error: unknown, fallback = 'Tool failed'): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error === null || error === undefined) return fallback;
  if (typeof error === 'number' || typeof error === 'boolean' || typeof error === 'bigint') {
    return String(error);
  }
  return fallback;
}
